import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import OwlCarousel from 'react-owl-carousel2';
import animations from './animations';
import Heading from "../../elements/Heading";

class OurTeam extends Component {

    constructor(props) {
        super(props);

        this.memberRefs = [];
        this.sceneController = null;
        this.state = {
            members: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                members: this.props.data.members
            });
            this.sceneController = animations.initialise(this, this.titleRef, this.subTitleRef);
        }
    }

    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setTitleRef(el) {
        this.titleRef = el;
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }

    renderBlurb(blurb) {
        return blurb.map((item, key) => {
            return (
                <p key={key}>{item}</p>
            );
        });
    }

    render() {
        const TeamMembers = this.state.members.map((member, key) => {
            let id = (key + 1);
            return (
                <div
                    key={key}
                    className="member"
                    data-pos={id}
                    id={'member' + id}
                    ref={el => this.memberRefs.push(el)}
                    onClick={el => animations.switchTeamMember(el)}
                >
                    <div className="avatar">
                        <img src={member.image} alt={member.name} />
                    </div>
                    <div className="text">
                        <h5>{member.name}</h5>
                        <h6>{member.title}</h6>
                        {this.renderBlurb(member.blurb)}
                    </div>
                </div>
            );
        });

        const options = {
            items: 1,
            loop: true,
            center: true,
            startPosition: 2,
            autoplay: false,
            autoHeight: true
        };

        return (
            <section className="our-team">
                <div className="row">
                    <div className="col-xs-12">
                        <Heading
                            title={this.props.data.title}
                            subTitle={this.props.data.subTitle}
                            setTitleRef={this.setTitleRef.bind(this)}
                            setSubTitleRef={this.setSubTitleRef.bind(this)}
                        />
                        <div className="team-container">
                            <BrowserView>
                                {TeamMembers}
                            </BrowserView>
                            <MobileView>
                                {this.state.members.length > 0 ?
                                    <OwlCarousel options={options}>
                                        {TeamMembers}
                                    </OwlCarousel>
                                : ''}
                            </MobileView>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
    
}

export default OurTeam;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/OurTeam/OurTeam.js